type FeatureProps = {
  title: string
  image: React.ReactNode
}

export function Feature({ title, image }: FeatureProps) {
  return (
    <div className="flex w-full flex-col items-center md:flex-row">
      <div className="flex-1 md:hidden">
        <p className="py-2 text-center font-md-nichrome text-28 font-medium leading-8 text-black lg:text-32">
          {title}
        </p>
      </div>
      <div className="flex flex-1 items-center justify-center">{image}</div>
    </div>
  )
}
